import { motion } from "framer-motion";
import { Car, CreditCard, Monitor, Truck } from "lucide-react";

import SectionHeader from "@/components/SectionHeader";

const steps = [
  {
    icon: Car,
    number: "01",
    title: "Anfahren",
    description:
      "Sie fahren die Station in Nalbach an und positionieren Anhänger oder Fahrzeug direkt an der Ausgabe.",
  },
  {
    icon: Monitor,
    number: "02",
    title: "Menge wählen",
    description:
      "Am Terminal wählen Sie Betonsorte und Menge passend zu Ihrem Bedarf.",
  },
  {
    icon: CreditCard,
    number: "03",
    title: "Bezahlen",
    description:
      "Die Bezahlung erfolgt bargeldlos per EC-/Kreditkarte. Registrierte Kunden nutzen zusätzlich den NFC-Chip.",
  },
  {
    icon: Truck,
    number: "04",
    title: "Laden & weiterarbeiten",
    description:
      "Der Beton wird direkt verladen. Danach geht es ohne Umwege zurück auf die Baustelle.",
  },
];

const StepsSection = () => {
  return (
    <section id="funktion" className="section-shell overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

      <div className="container mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.86fr)_minmax(0,1.14fr)] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeader
              eyebrow="Ablauf"
              title={
                <>
                  Vier klare Schritte.
                  <br />
                  Kein unnötiger Aufwand.
                </>
              }
              description="Die Nutzerführung bleibt bewusst einfach. Jeder Schritt hat genau eine Aufgabe und der gesamte Ablauf ist in wenigen Minuten erledigt."
            />

          </div>

          <div className="relative">
            <div className="absolute bottom-0 left-[28px] top-0 hidden w-px bg-gradient-to-b from-primary/25 via-white/8 to-transparent md:block" />

            <div className="space-y-4">
              {steps.map((step, index) => (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{ delay: index * 0.12, duration: 0.55 }}
                  className="surface-panel group grid gap-5 p-6 transition-colors duration-300 hover:border-primary/20 md:grid-cols-[56px_84px_minmax(0,1fr)] md:items-start md:gap-7 md:p-7"
                >
                  <div className="hidden h-14 w-14 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10 md:flex">
                    <step.icon className="h-5 w-5 text-primary" />
                  </div>

                  <div className="flex items-center gap-4 md:block">
                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10 md:hidden">
                      <step.icon className="h-5 w-5 text-primary" />
                    </div>
                    <span className="font-display text-3xl leading-none text-primary/90 md:text-4xl">
                      {step.number}
                    </span>
                  </div>

                  <div>
                    <h3 className="font-display text-2xl uppercase leading-none text-foreground md:text-[2rem]">
                      {step.title}
                    </h3>
                    <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground md:text-base">
                      {step.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
